<template>
  <div class="root row">
    <div class="col-md-12 no-pad">
      <table class="table small">
        <thead>
          <tr>
            <th class="col-md-2">Needs Approval</th>
            <template v-if="hasProgramName">
              <th class="col-md-3">{{ programLabel }}</th>
            </template>
            <template v-if="hasSupplier">
              <th class="col-md-3">Supplier</th>
            </template>
            <template v-if="hasDueDate">
              <th class="col-md-2">Due Date</th>
            </template>
            <th class="col-md-2">Amount</th>
          </tr>
        </thead>
      </table>
      <div class="scroller">
        <table class="table small">
          <tbody>
            <tr v-for="(item, i) in list" :key="i">
              <td class="col-md-2">{{ item.NeedsApproval }}</td>
              <template v-if="hasProgramName">
                <td v-if="item.ProgramName" class="col-md-3">{{ item.ProgramName }}</td>
              </template>
              <template v-if="hasSupplier">
                <td v-if="item.SupplierName" class="col-md-3">{{ item.SupplierEoNumber ? item.SupplierName + ' (' + item.SupplierEoNumber + ')' : item.SupplierName }}</td>
              </template>
              <template v-if="hasDueDate">
                <td v-if="item.DueDate" class="col-md-2">{{ item.DueDate }}</td>
              </template>
              <!-- PRODUCTDEV-5882 / 5890 (pool funding): any POOL approval - a new pool card OR a Daily Spend
                   Limit change - shows the Daily Spend Limit instead of the Amount (the per-card Amount is the
                   $0.00 initial load for a pool card and must never be shown here). Key on IsPoolFunding
                   (a string "True"/"False" from the backend), NOT on Type or Amount, so every pool item -
                   including the DSL-change type and a "None" limit - renders the Daily Spend Limit. -->
              <td class="col-md-2">
                <template v-if="String(item.IsPoolFunding).toLowerCase() === 'true'">Daily Spend Limit: {{ item.DailySpendLimit }}</template>
                <template v-else>{{ item.Amount }}</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: Array,
      programLabel: String
    },
    computed: {
      hasProgramName() {
        return this.list.some(item => item.ProgramName)
      },
      hasSupplier() {
        return this.list.some(item => item.SupplierName)
      },
      hasDueDate() {
        return this.list.some(item => item.DueDate)
      }
    }
  }
</script>


<style lang="scss" scoped>

  @import "~@/assets/sass/_variables.scss";

  .root {
    margin: 10px 0 20px 0;
  }

  .table {
    margin: 0;
  }

    .table > thead > tr > th {
      border: none;
      padding: 5px 0;
    }

    .table > tbody > tr:first-child > td {
      border: none;
    }

    .table > tbody > tr > td {
      padding: 5px 0;
    }

  .scroller {
    max-height: 168px;
    overflow-y: auto;

    @include theme {
      border-top: 1px solid v(ink-light);
      border-bottom: 1px solid v(ink-light);
    }
  }

  </style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/items-list.vue